import { render, staticRenderFns } from "./InvoiceStatusSelectInputWidget.vue?vue&type=template&id=4ef6aeba&scoped=true"
import script from "./InvoiceStatusSelectInputWidget.vue?vue&type=script&lang=js"
export * from "./InvoiceStatusSelectInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef6aeba",
  null
  
)

export default component.exports